<template>
    <generic-page>
        <div
            class="d-flex align-items-center justify-content-between mt-3 mb-2"
        >
            <h5 class="mb-0">Creators</h5>
            <div class="d-flex align-items-center">
                <b-dropdown
                    text="Sort"
                    variant="light"
                    right
                    class="rounded-pill bg-white mr-2"
                >
                    <b-dropdown-item @click="setFilter('Earnings')">
                        Earnings
                    </b-dropdown-item>
                    <b-dropdown-item @click="setFilter('Newest')">
                        Newest
                    </b-dropdown-item>
                    <b-dropdown-item @click="setFilter('Days Active')">
                        Days Active
                    </b-dropdown-item>
                    <b-dropdown-item @click="setFilter('Activity Count')">
                        Activity Count
                    </b-dropdown-item>
                </b-dropdown>

                <affiliate-creator-create />
            </div>
        </div>

        <div v-if="fshUrl" class="rounded p-3 bg-white text-left mb-2">
            <h5 class="mb-0">Creator Invite Link</h5>

            <div class="small text-secondary mt-1">
                This landing page is made for women interested in earning
                online, so potential creators may be more likely to sign up
                from it. Either of your links will track signups back to your
                account.
            </div>

            <b-input-group class="mt-2">
                <b-form-input :value="fshUrl" readonly />
                <b-input-group-append>
                    <b-btn v-if="copiedFshUrl" variant="success">
                        <font-awesome-icon icon="fa-light fa-check" />
                        Copied
                    </b-btn>
                    <b-btn v-else @click="copyFshUrl" variant="primary">
                        {{ $t("Copy") }}
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
        </div>

        <div v-if="users">
            <b-link
                style="all: unset"
                :to="{
                    name: 'affiliateCreatorView',
                    params: {
                        id: user.standardMap.id,
                    },
                }"
                :key="user.standardMap.id"
                v-for="user in users"
            >
                <user-standard-avatar
                    :timestamp="user.standardMap.created"
                    :standardMap="user.standardMap"
                    :nonPrimaryPhotos="false"
                    :hideBadges="true"
                    :userBetweenStatus="false"
                    size="small"
                    class="border-light border-top"
                >
                    <coin-badge
                        label="Total Earnings"
                        v-if="user.totalCreditsEarned"
                        :amount="user.totalCreditsEarned"
                    />
                </user-standard-avatar>
            </b-link>
        </div>
        <div v-else>
            <generic-loading />
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<script>
import copy from "clipboard-copy";

import UserStandardAvatar from "@/components/user/UserStandardAvatar";
import AffiliateCreatorCreate from "@/components/affiliate/creator/AffiliateCreatorCreate";
import GenericPagination from "@/components/utility/GenericPagination";

export default {
    data() {
        return {
            users: false,
            hasMorePages: false,
            page: 1,
            fshUrl: null,
            copiedFshUrl: false,
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        setFilter(filter) {
            const query = {};

            if (filter) {
                query.filter = filter;
            }

            this.$router
                .push({
                    name: "affiliateCreatorIndex",
                    query,
                })
                .then(() => {
                    this.refresh();
                });
        },
        refresh() {
            this.users = null;

            this.api
                .post("/affiliate/creator/index", {
                    page: this.page,
                    filter: this.$route.query?.filter,
                })
                .then((response) => {
                    if (response?.data?.users) {
                        this.users = response.data.users;
                    }

                    if (response?.data?.fshUrl) {
                        this.fshUrl = response.data.fshUrl;
                    }

                    this.hasMorePages = response.data.hasMorePages;
                });
        },
        copyFshUrl() {
            copy(this.fshUrl);

            this.copiedFshUrl = true;

            setTimeout(() => {
                this.copiedFshUrl = false;
            }, 3000);
        },
        next() {
            this.page++;
            this.$scrollToTop();
            this.refresh();
        },
        previous() {
            this.page--;
            this.$scrollToTop();
            this.refresh();
        },
    },
    components: {
        UserStandardAvatar,
        AffiliateCreatorCreate,
        GenericPagination,
    },
};
</script>